module.exports = __webpack_public_path__ + "img/sntf.317e1e43.png";